import React from 'react'

const RootStoreContext = React.createContext(false);

export default RootStoreContext;
